/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Batch Export" |
*
* @param {Explorer_Info_Batch_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_export_button = /** @type {((inputs?: Explorer_Info_Batch_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation par lots")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapel-Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione in batch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный экспорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em lote")
	return /** @type {LocalizedString} */ ("Batch Export")
});